var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M31.1666 9.16663V3.66663H7.33325V40.3333H36.6666V9.16663H31.1666Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41675 3.66667C6.41675 3.16041 6.82715 2.75 7.33341 2.75H31.1667C31.4099 2.75 31.643 2.84658 31.8149 3.01849L37.3149 8.51849C37.4868 8.69039 37.5834 8.92355 37.5834 9.16667V40.3333C37.5834 40.8396 37.173 41.25 36.6667 41.25H7.33341C6.82715 41.25 6.41675 40.8396 6.41675 40.3333V3.66667ZM8.25008 4.58333V39.4167H35.7501V9.54636L30.7871 4.58333H8.25008Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 14.6667C13.75 14.1604 14.1604 13.75 14.6667 13.75H29.3333C29.8396 13.75 30.25 14.1604 30.25 14.6667C30.25 15.1729 29.8396 15.5833 29.3333 15.5833H14.6667C14.1604 15.5833 13.75 15.1729 13.75 14.6667Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 22C13.75 21.4938 14.1604 21.0834 14.6667 21.0834H29.3333C29.8396 21.0834 30.25 21.4938 30.25 22C30.25 22.5063 29.8396 22.9167 29.3333 22.9167H14.6667C14.1604 22.9167 13.75 22.5063 13.75 22Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 29.3333C13.75 28.827 14.1604 28.4166 14.6667 28.4166H29.3333C29.8396 28.4166 30.25 28.827 30.25 29.3333C30.25 29.8396 29.8396 30.25 29.3333 30.25H14.6667C14.1604 30.25 13.75 29.8396 13.75 29.3333Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8159 2.8198C31.1584 2.67792 31.5527 2.75635 31.8148 3.01851L37.3148 8.51851C37.577 8.78068 37.6554 9.17495 37.5136 9.51749C37.3717 9.86002 37.0374 10.0834 36.6667 10.0834H31.1667C30.6604 10.0834 30.25 9.67295 30.25 9.16669V3.66669C30.25 3.29594 30.4733 2.96169 30.8159 2.8198ZM32.0833 5.87972V8.25003H34.4536L32.0833 5.87972Z",
    fill: props.color
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.19bc16d5fb108032fea840a8ddc0e8a1.svg";
export { ForwardRef as ReactComponent };